export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolDiamond: number = 1; //Káro
    public static readonly SymbolSpade: number = 2; //Pika
    public static readonly SymbolClub: number = 3; //Tref
    public static readonly SymbolHeart: number = 4; //Srdce
    public static readonly SymbolCornCob: number = 5; //Kukuřičný klas
    public static readonly SymbolRadio: number = 6; //Rádio
    public static readonly SymbolMicrophone: number = 7; //Mikrofon
    public static readonly SymbolDollar: number = 8; //Dolar - přívěšek na krk
    public static readonly SymbolFox: number = 9; //Wild - Liška
    public static readonly SymbolBonus: number = 10; //Bonus - Slepice, 5 variant;
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/